module.exports = __webpack_public_path__ + "media/images/redcross-a6a06c11de0463877e16baad3d068982.png";